import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { buildApiUrl, buildPublicFileUrl } from "../config/api";
import AiRoomPreview from "./AiRoomPreview";
const styles = [
  ".ai-preview-open{overflow:hidden}.ai-room-floating-trigger{position:fixed;right:22px;bottom:22px;z-index:900;display:flex;align-items:center;gap:11px;padding:13px 18px;border:1px solid #c9a95a;border-radius:999px;background:#15343b;color:#fff;box-shadow:0 12px 36px #06191f55;cursor:pointer;text-align:left}.ai-room-floating-trigger strong,.ai-room-floating-trigger small{display:block}.ai-room-floating-trigger small{color:#ffffffb5;font-size:.72rem}",
  ".ai-preview-backdrop{position:fixed;inset:0;z-index:1200;display:grid;place-items:center;padding:24px;background:#03080ade;backdrop-filter:blur(8px)}.ai-preview-modal{position:relative;width:min(1120px,100%);max-height:calc(100dvh - 48px);overflow:auto;border-radius:20px;background:#f8f4eb;color:#142024;box-shadow:0 30px 90px #0008}.ai-preview-close{position:absolute;top:18px;right:20px;z-index:5;width:44px;height:44px;border:0;border-radius:50%;background:#fff;font-size:28px;cursor:pointer}",
  ".ai-preview-heading{padding:28px 84px 22px 32px;border-bottom:1px solid #14202418}.ai-preview-heading>span{color:#92702e;font-size:.76rem;font-weight:800;letter-spacing:.14em;text-transform:uppercase}.ai-preview-heading h2{margin:5px 0 7px;font-size:clamp(1.7rem,3vw,2.5rem)}.ai-preview-heading p{max-width:760px;margin:0;color:#58666a;line-height:1.5}",
  ".ai-preview-layout{display:grid;grid-template-columns:minmax(0,1fr) 280px;gap:24px;padding:26px 30px 30px}.ai-preview-canvas{position:relative;min-height:500px;display:grid;place-items:center;overflow:hidden;border-radius:16px;background:linear-gradient(145deg,#e3dfd5,#d5d0c5)}.ai-preview-canvas canvas{max-height:680px}.ai-preview-canvas:has(canvas),.ai-preview-canvas:has(video){background:#091316}",
  ".ai-preview-dropzone{width:calc(100% - 64px);min-height:340px;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:36px;border:2px dashed #a57c2e;border-radius:16px;text-align:center}.ai-preview-dropzone label{display:flex;flex-direction:column;gap:7px;align-items:center;cursor:pointer}.ai-preview-dropzone label strong{font-size:1.2rem}.ai-preview-dropzone label span{color:#637075}.ai-preview-dropzone input,.ai-preview-replace input{position:absolute;width:1px;height:1px;opacity:0}.ai-preview-dropzone button{width:min(340px,100%)}",
  ".ai-preview-controls{display:flex;flex-direction:column;gap:16px}.ai-preview-controls>div label{display:block;margin-bottom:7px;font-size:.82rem;font-weight:800;letter-spacing:.05em;text-transform:uppercase}.ai-preview-controls select{width:100%;padding:12px 13px;border:1px solid #bfc3bd;border-radius:9px;background:#fff}.ai-preview-controls input[type=range]{width:100%;accent-color:#9b742d}",
  ".ai-preview-replace,.ai-preview-generate{width:100%;padding:12px 14px;border-radius:9px;font-weight:800;cursor:pointer}.ai-preview-replace{border:1px solid #b7a77f;background:transparent;color:#142024}.ai-preview-generate{border:0;background:#142f36;color:#fff}.ai-preview-generate:disabled{cursor:not-allowed;opacity:.42}.ai-preview-controls small{color:#687579;line-height:1.45}.ai-preview-error{margin:0;padding:10px;border-radius:7px;background:#fff0ed;color:#9c3027;font-size:.86rem}",
  ".ai-preview-toolbar{display:grid;grid-template-columns:1fr 1fr;gap:8px}.ai-preview-advanced{border-top:1px solid #1420241c;border-bottom:1px solid #1420241c;padding:11px 0}.ai-preview-advanced summary{font-weight:800;cursor:pointer}.ai-preview-advanced>div{margin-top:14px}.ai-preview-welcome{padding:8px}.ai-preview-welcome>strong{font-size:1.05rem}.ai-preview-welcome ol{display:grid;gap:18px;margin:22px 0;padding:0;list-style:none;counter-reset:steps}.ai-preview-welcome li{position:relative;padding-left:38px;counter-increment:steps}.ai-preview-welcome li:before{content:counter(steps);position:absolute;left:0;top:0;display:grid;place-items:center;width:26px;height:26px;border-radius:50%;background:#e8ddc3;color:#79591f;font-weight:800}.ai-preview-welcome li b,.ai-preview-welcome li span{display:block}.ai-preview-welcome li span{margin-top:3px;color:#647175;font-size:.86rem;line-height:1.4}.ai-preview-welcome>p{padding:12px;border-radius:8px;background:#edf2ed;color:#425148;font-size:.82rem}",
  "@media(max-width:760px){.ai-room-floating-trigger{right:12px;bottom:12px}.ai-preview-backdrop{padding:0}.ai-preview-modal{width:100%;min-height:100dvh;max-height:100dvh;border-radius:0}.ai-preview-heading{padding:20px 70px 16px 18px}.ai-preview-heading p{font-size:.88rem}.ai-preview-layout{grid-template-columns:1fr;padding:14px 16px 28px}.ai-preview-canvas{min-height:330px}.ai-preview-dropzone{width:calc(100% - 28px);min-height:280px;padding:22px}}",
  "@media(max-width:480px){.ai-room-floating-trigger{right:max(10px,env(safe-area-inset-right));bottom:max(10px,env(safe-area-inset-bottom));padding:11px 14px}.ai-room-floating-trigger small{display:none}.ai-preview-heading h2{font-size:1.55rem}.ai-preview-heading p{font-size:.82rem}.ai-preview-close{top:12px;right:12px}.ai-preview-layout{padding:12px 12px max(22px,env(safe-area-inset-bottom))}.ai-preview-canvas{min-height:260px}.ai-preview-dropzone{width:calc(100% - 20px);min-height:240px;padding:18px}.ai-preview-toolbar{grid-template-columns:1fr}}",
  "@media(max-height:600px) and (orientation:landscape){.ai-preview-heading{padding-top:14px;padding-bottom:12px}.ai-preview-heading p{display:none}.ai-preview-layout{grid-template-columns:minmax(0,1fr) 250px;padding:12px;gap:12px}.ai-preview-canvas{min-height:280px}.ai-preview-dropzone{min-height:230px}.ai-preview-controls{gap:10px}}",
].join("");

const assetUrl = (path = "") =>
  /^https?:\/\//i.test(path)
    ? path
    : path.startsWith("/uploads") || path.startsWith("uploads/")
      ? buildPublicFileUrl(path)
      : path;

const parseMediaList = (value) => {
  if (Array.isArray(value)) return value;
  if (typeof value !== "string" || !value.trim()) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const mediaPath = (item) =>
  typeof item === "string"
    ? item
    : item?.filePath || item?.file_path || item?.path || item?.url || item?.src || "";

const getRoomPreviewAsset = (product) => {
  if (!product) return { path: "", preframed: false };

  const media = [
    ...parseMediaList(product.productMedia),
    ...parseMediaList(product.product_media),
    ...parseMediaList(product.media),
    ...parseMediaList(product.mediaItems),
    ...parseMediaList(product.media_items),
  ];

  const dedicated = media.find((item) => {
    const role = String(item?.role || item?.mediaType || item?.media_type || "").toLowerCase();
    const path = mediaPath(item).toLowerCase();
    return role === "room-preview" || role === "ar-preview" || /(?:^|\/)room-preview(?:[-.])/.test(path);
  });

  if (dedicated) return { path: mediaPath(dedicated), preframed: true };

  return {
    path: product.image || product.mainImage || product.main_image || product.coverImage || product.cover_image || "",
    preframed: false,
  };
};

const AiRoomPreviewLauncher = () => {
  const { pathname } = useLocation();
  const [product, setProduct] = useState(null);
  const [folderPreviewAsset, setFolderPreviewAsset] = useState(null);
  const [open, setOpen] = useState(false);
  const slug = pathname.match(/^\/product\/([^/]+)\/?$/)?.[1] || "";

  useEffect(() => {
    setOpen(false); setProduct(null);
    if (!slug) return undefined;
    const controller = new AbortController();
    fetch(buildApiUrl(`/products/${slug}`), { signal: controller.signal })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.message || "Could not load product preview.");
        return data;
      })
      .then((data) => { if (data.success) setProduct(data.product); })
      .catch(() => {});
    return () => controller.abort();
  }, [slug]);

  useEffect(() => {
    setFolderPreviewAsset(null);
    if (!product) return undefined;

    const mediaAsset = getRoomPreviewAsset(product);
    if (mediaAsset.preframed) return undefined;

    const basePath = String(product.publicBasePath || product.public_base_path || "").replace(/\/$/, "");
    if (!basePath) return undefined;

    const controller = new AbortController();
    const findFolderPreview = async () => {
      for (const extension of ["webp", "avif", "jpg"]) {
        const path = `${basePath}/room-preview.${extension}`;
        try {
          const response = await fetch(assetUrl(path), { method: "HEAD", signal: controller.signal });
          if (response.ok) {
            setFolderPreviewAsset({ path, preframed: true });
            return;
          }
        } catch (error) {
          if (error.name === "AbortError") return;
        }
      }
    };

    findFolderPreview();
    return () => controller.abort();
  }, [product]);

  useEffect(() => {
    const handleOpenPreview = (event) => {
      if (!event.detail?.product) return;
      setProduct(event.detail.product);
      setOpen(true);
    };

    window.addEventListener("mayachitro:open-room-preview", handleOpenPreview);
    return () => window.removeEventListener("mayachitro:open-room-preview", handleOpenPreview);
  }, []);

  const previewAsset = folderPreviewAsset || getRoomPreviewAsset(product);
  const showFloatingTrigger = Boolean(slug && product && previewAsset.path);

  return <><style>{styles}</style>
    {showFloatingTrigger && <button className="ai-room-floating-trigger" type="button" onClick={() => setOpen(true)}><span aria-hidden="true">✦</span><span><strong>Preview in my room</strong><small>Room photo or live AR · Free</small></span></button>}
    {open && previewAsset.path && <AiRoomPreview artworkUrl={assetUrl(previewAsset.path)} productTitle={product.title} artworkHasFrame={previewAsset.preframed} onClose={() => setOpen(false)} />}
  </>;
};

export default AiRoomPreviewLauncher;
